/**
 * Finalidades de cálculo que substituem o valor da linha do contrato.
 *
 * Espelha `FINALIDADES_VALOR` de `api/utils/subsidioValorContratoFormula.js`.
 * Duas nomenclaturas convivem nas bases: VALOR_CONTRATO e MULTIPLICADOR_VALOR.
 * São equivalentes — o que estiver gravado continua valendo.
 */
export const FINALIDADES_VALOR = ["VALOR_CONTRATO", "MULTIPLICADOR_VALOR"];

export function isFinalidadeValor(finalidade) {
  return FINALIDADES_VALOR.indexOf(String(finalidade || "")) !== -1;
}

/**
 * Cálculos que o vínculo de valor do contrato aceita
 * (`subsidio_contrato_calculos`, no máximo um). GERAL entra por ser um cálculo
 * sem vocação declarada.
 */
export function aceitaComoCalculoValor(finalidade) {
  const f = String(finalidade || "GERAL");
  return isFinalidadeValor(f) || f === "GERAL";
}

/**
 * Cálculos que podem ser usados como filtro da linha de valor do contrato —
 * o que restringe a grandeza antes de o valor incidir sobre ela.
 *
 * Espelha `validateReferencias` de `api/models/ContratoValoresTipoVeiculo.js`.
 * FILTRO_VIAGEM é a vocação declarada; GERAL entra por não ter vocação. Valor
 * de contrato fica de fora: pertence ao outro vínculo.
 */
export function aceitaComoFiltroLinha(finalidade) {
  const f = String(finalidade || "GERAL");
  return f === "FILTRO_VIAGEM" || f === "GERAL";
}

/**
 * Finalidade dos cálculos que são a grandeza de uma linha de valor do contrato
 * (`valor × cálculo`). Sempre numéricos; `agregacao_resultado` diz como os
 * resultados das chaves viram a quantidade da linha.
 *
 * Espelha `FINALIDADE_GRANDEZA` de `api/models/SubsidioMotorCatalogo.js`.
 */
export const FINALIDADE_GRANDEZA = "GRANDEZA";

export function isFinalidadeGrandeza(finalidade) {
  return String(finalidade || "") === FINALIDADE_GRANDEZA;
}

/**
 * Cálculos que podem ser a grandeza da linha de valor do contrato. Só os de
 * finalidade GRANDEZA: um GERAL não diz como agregar os resultados das chaves.
 *
 * Espelha `validateReferencias` de `api/models/ContratoValoresTipoVeiculo.js`.
 */
export function aceitaComoGrandezaLinha(finalidade) {
  return isFinalidadeGrandeza(finalidade);
}
